import React, { Component } from 'react';
import globalURL from 'helper/url';
import ActivityIndicator from '@lyearn-team/frontend-components/dist/Loader';
import DarkBoxInput from '@lyearn-team/frontend-components/dist/Input/DarkBoxInput';
import DarkButton from '@lyearn-team/frontend-components/dist/Button/DarkButton';
import { ResetPasswordErrors } from '../shared/consts';
import {
  FixWidthColumn,
  CompanyPageWrapper,
  GlobalMessage,
  inputClass,
  buttonClass,
  passwordWrapperClass,
  confirmPasswordWrapperClass,
  GlobalErrorWrapper,
  PasswordInputDiv
} from './styles';
import { LoginContentHeading, LoginNormalText } from '../styles';

export default class DarkResetPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      password: '',
      confirmPassword: '',
      loading: false,
      errorMessage: '',
      globalError: '',
      successMessage: '',
      goToLogin: false
    };
  }

  onPasswordChange = e => {
    this.clearAllState();
    this.setState({ password: e.target.value });
  };

  onConfirmPasswordChange = e => {
    this.clearAllState();
    this.setState({ confirmPassword: e.target.value });
  };

  onEnter = e => {
    if (e.keyCode === 13) {
      this.resetPassword();
    }
  };

  clearAllState = () => {
    const { errorMessage, globalError, successMessage } = this.state;
    if (errorMessage) {
      this.setState({ errorMessage: '', goToLogin: false });
    }
    if (globalError) {
      this.setState({ globalError: '', goToLogin: false });
    }
    if (successMessage) {
      this.setState({ successMessage: '', goToLogin: false });
    }
  };

  validateInputs = () => {
    const { password, confirmPassword } = this.state;
    if (!password) {
      this.setState({ errorMessage: ResetPasswordErrors.PASSWORD_REQUIRED });
      return false;
    }
    if (!confirmPassword) {
      this.setState({ errorMessage: ResetPasswordErrors.CONFIRM_PASSWORD_REQUIRED });
      return false;
    }
    if (password !== confirmPassword) {
      this.setState({ errorMessage: ResetPasswordErrors.DO_NOT_MATCH });
      return false;
    }
    return true;
  };

  resetPassword = event => {
    event.preventDefault();
    if (this.state.goToLogin) {
      window.location.href = '/#/login';
    }
    if (!this.validateInputs()) return false;
    this.setState({ loading: true });
    const { confirmPassword } = this.state;
    const globalErrorMessage = (
      <GlobalMessage>
        Sorry! There is some problem in resetting password. Please reach out to us at&nbsp;
        <a href="mailto:support@lyearn.com" style={{ 'text-decoration': 'none' }}>
          support@lyearn.com
        </a>
      </GlobalMessage>
    );
    const reqData = {
      password: confirmPassword
    };
    const url = `${globalURL.awsEndpoint}/resetuserpassword?access_token=${
      window.location.search.split('accessToken=')[1]
    }`;
    fetch(url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(reqData)
    })
      .then(response => response.json())
      .then(data => {
        this.setState({ loading: false });
        if (data.error) {
          this.setState({ globalError: globalErrorMessage });
        } else {
          this.setState({
            successMessage: <GlobalMessage>Password has been changed successfully.</GlobalMessage>,
            goToLogin: true
          });
        }
      })
      .catch(err => {
        console.log('Error', err);
      });
    return true;
  };

  renderActivityIndicator = () => (
    <ActivityIndicator
      svgColor="#fff"
      style={{ marginRight: '6px', fill: '#fff' }}
      width={16}
      height={16}
    />
  );

  render() {
    const {
      password,
      confirmPassword,
      loading,
      errorMessage,
      globalError,
      successMessage
    } = this.state;
    let icon = '';
    if (loading) {
      icon = this.renderActivityIndicator();
    }
    let confirmPasswordError = '';
    if (errorMessage === ResetPasswordErrors.DO_NOT_MATCH) {
      confirmPasswordError = 'Passwords do not match';
    }

    return (
      <CompanyPageWrapper className="pageWrapper">
        {/* {window.bowser.mobile ? <FixMargin /> : ''} */}
        <LoginContentHeading>Reset Password</LoginContentHeading>
        <LoginNormalText>Please enter new password.</LoginNormalText>
        <form className={FixWidthColumn} onSubmit={this.resetPassword}>
          <div className={PasswordInputDiv}>
            <DarkBoxInput.Password
              placeholder="New password"
              value={password}
              required={true}
              onChange={this.onPasswordChange}
              className={inputClass}
              passwordWrapperClassName={passwordWrapperClass}
            />
            <DarkBoxInput.Password
              placeholder="Confirm new password"
              value={confirmPassword}
              required={true}
              onChange={this.onConfirmPasswordChange}
              className={inputClass}
              passwordWrapperClassName={confirmPasswordWrapperClass}
            />
            <GlobalErrorWrapper
              style={{ visibility: globalError === 'constant' ? 'hidden' : undefined }}
            >
              {globalError || confirmPasswordError || <div>&nbsp;</div>}
            </GlobalErrorWrapper>
            {successMessage}
          </div>
          <DarkButton
            className={buttonClass}
            type="submit"
            disabled={loading || !password || !confirmPassword}
          >
            {icon}
            {this.state.goToLogin ? 'GO TO LOGIN' : 'CONTINUE'}
          </DarkButton>
        </form>
      </CompanyPageWrapper>
    );
  }
}
